import PropTypes from 'prop-types';
import React from 'react';

import { useTranslation } from 'react-i18next';
import RatesGroup from './ratesGroup';

import { Table, Card, Icon } from '@weezevent/nacre';
import { filterCells } from './utils';
import StyleRM from '../rates/components/rateManager.module.css';
import LoadingTable from '../../components/loadingTable';

const { TBody: TableBody } = Table;

function RatesTableHeader({ tableCells, event, orgaWithChart, mode, active }) {
    const { t } = useTranslation();
    let cells = tableCells.filter(column => filterCells(event, column, orgaWithChart)).map((column, index) => <th key={`rate-header-${index}`}>{column.header}</th>);

    return (
        <Table.THead>
            <Table.Tr active={active}>
                {cells}
                {(mode === 'rate-list' || mode === 'resale') && (
                    <>
                        <th>{t('ticket.common.cta.actions')}</th>
                        {!event && <th>{t('ticket.rates.position')}</th>}
                    </>
                )}
            </Table.Tr>
        </Table.THead>
    );
}

RatesTableHeader.defaultProps = {
    event: null,
    orgaWithChart: false
};

RatesTableHeader.propTypes = {
    tableCells: PropTypes.array.isRequired,
    event: PropTypes.object,
    orgaWithChart: PropTypes.bool
};

export default function RatesTable({
    t,
    tableCells,
    event,
    organizationId,
    groups,
    rates,
    inventories,
    categories,
    reloadList,
    handleElementsList,
    selectedGroups,
    selectedRates,
    allSelected,
    handleAllClick,
    RateClass,
    GroupClass,
    orgaWithChart,
    hideEmptyGroup,
    extraRow = null,
    onToggleGroup,
    mode,
    selectable,
    isLoading,
    getQuotaTakenRate = () => {},
    quotaTakenByGroup,
    settings,
    customActions = null,
    onRowClick = null
}) {
    // Rates without category, need to be displayed inside a "null" group.
    const groupsToDisplay = [null].concat(groups);
    return (
        <React.Fragment>
            <Table useNew className={StyleRM['rates-list-table']} onSelectAll={handleAllClick} selectable={selectable}>
                <RatesTableHeader tableCells={tableCells} mode={mode} event={event} orgaWithChart={orgaWithChart} active={allSelected} />
                <TableBody>
                    {extraRow}
                    {groupsToDisplay.map(group => {
                        let selected = group !== null && !!selectedGroups.find(sgroup => sgroup?.pk === group.pk);
                        return (
                            <RatesGroup
                                tableCells={tableCells}
                                hideEmptyGroup={hideEmptyGroup}
                                event={event}
                                organizationId={organizationId}
                                rates={rates}
                                group={group}
                                onRateSelected={handleElementsList}
                                onGroupSelected={handleElementsList}
                                selectedRates={selectedRates}
                                reloadList={reloadList}
                                key={group ? group.pk : -1}
                                categories={categories}
                                inventories={inventories}
                                isSelected={selected}
                                groups={groups}
                                GroupClass={GroupClass}
                                RateClass={RateClass}
                                orgaWithChart={orgaWithChart}
                                onToggleGroup={onToggleGroup}
                                mode={mode}
                                getQuotaTakenRate={getQuotaTakenRate}
                                quotaTakenByGroup={quotaTakenByGroup}
                                settings={settings}
                                customActions={customActions}
                                onRowClick={onRowClick}
                            />
                        );
                    })}
                </TableBody>
            </Table>
            <LoadingTable loading={isLoading} />
            {!isLoading && Boolean(!rates.length) && <Card.EmptyState className={StyleRM['not_found']} title={t('ticket.rates.no_rates')} icon={<Icon name="list" />} />}
        </React.Fragment>
    );
}

RatesTable.defaultProps = {
    event: null,
    inventories: null,
    categories: null,
    groups: [],
    allSelected: false,
    orgaWithChart: false,
    selectable: true,
    isLoading: false,
    quotaTakenByGroup: {},
    settings: {}
};

RatesTable.propTypes = {
    t: PropTypes.func.isRequired,
    tableCells: PropTypes.array.isRequired,
    event: PropTypes.object,
    organizationId: PropTypes.number.isRequired,
    rates: PropTypes.array.isRequired,
    selectedRates: PropTypes.array.isRequired,
    reloadList: PropTypes.func.isRequired,
    categories: PropTypes.array,
    inventories: PropTypes.array,
    groups: PropTypes.array,
    handleElementsList: PropTypes.func.isRequired,
    allSelected: PropTypes.bool,
    selectedGroups: PropTypes.array.isRequired,
    handleAllClick: PropTypes.func.isRequired,
    RateClass: PropTypes.func.isRequired,
    GroupClass: PropTypes.func.isRequired,
    orgaWithChart: PropTypes.bool,
    hideEmptyGroup: PropTypes.bool,
    isLoading: PropTypes.bool,
    quotaTakenByGroup: PropTypes.object,
    settings: PropTypes.object
};
